export const MOBILE_MONEY_REGEX = "/^(?:(\\+)?237|00237)?(?:2|3|6)(?:2|3|5|6|7|8|9)[\\d]{7}$/mi";
